module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/rc-switch/es/index.js
// module id = 386
// module chunks = 0